export const defaultNotificationPreferences = {
  goalReminders: true, expenseAlerts: true, insights: true, weeklyReports: true, billReminders: true
};
export type NotificationPreferences = typeof defaultNotificationPreferences;
export const notificationPreferenceForType: Record<string, keyof NotificationPreferences> = {
  goal_reminder: 'goalReminders', expense_alert: 'expenseAlerts', insight: 'insights',
  weekly_report: 'weeklyReports', bill_reminder: 'billReminders'
};
export function readNotificationPreferences(): NotificationPreferences {
  try {
    const saved = JSON.parse(localStorage.getItem('notificationSettings') || '{}');
    return Object.fromEntries(Object.entries(defaultNotificationPreferences).map(([key, fallback]) =>
      [key, typeof saved?.[key] === 'boolean' ? saved[key] : fallback])) as NotificationPreferences;
  } catch { return { ...defaultNotificationPreferences }; }
}
export function notificationPath(type?: string): string {
  switch (type) {
    case 'goal_reminder': return '/plan/goals';
    case 'expense_alert': return '/activity';
    case 'bill_reminder': return '/plan';
    default: return '/dashboard';
  }
}
